import { render, staticRenderFns } from "./category-med.vue?vue&type=template&id=4926b6f4"
import script from "./category-med.vue?vue&type=script&lang=js"
export * from "./category-med.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports